// This cookie stores only a user-requested privacy preference, never a visitor ID.
export const PLAUSIBLE_OPTOUT_COOKIE = 'idmanify_plausible_optout';
export function plausibleOptedOut(target) {
  if (target.__idmanifyPlausibleOptOut === true) return true;
  try {
    const cookies = target.document?.cookie || '';
    const entries = new Map(
      cookies.split(';').map((part) => {
        const [key, ...value] = part.trim().split('=');
        return [key, value.join('=')];
      })
    );
    if (entries.has(PLAUSIBLE_OPTOUT_COOKIE))
      return entries.get(PLAUSIBLE_OPTOUT_COOKIE) !== '0';
    // Version 2 explicitly included Plausible in the statistics choice.
    const old = JSON.parse(
      decodeURIComponent(entries.get('idmanify_consent') || 'null')
    );
    return old?.version === 2 && old.analytics === false;
  } catch {
    return true; // Unreadable privacy preferences fail closed.
  }
}
